/** Идентификаторы пунктов главного меню для привязки бейджей непрочитанных. */
export const SIDEBAR_MENU_IDS = {
  APPLICATIONS: 'D6DE2E0E-40C3-44A1-B2F0-56B597BD6395',
  TECHNICAL_SUPPORT: 'DE52752C-FA0B-4096-9330-E5DB6367ECF3',
  APPLICATION_TARGET_ASSISTANCE: 'DC7197A6-5BF8-405B-A06E-61B1E4ECD6B2',
  APPLICATION_EVENTS: '00CE5A5B-08D5-4CAC-94E8-71218D60E01F',
  APPLICATION_MUTUAL_AID_BOARD: 'F824A6CB-18C6-409C-9E2B-A63216CEBAFD',
  APPLICATION_BECOME_VOLUNTEER: 'DB1B52C6-D528-4ED0-A940-44735DC0FE38',
  APPLICATION_HELP_WITH_TASK: 'DA0E3F60-AC41-499D-987E-A11FF5DC1C49',
  APPLICATION_PRESENTS: '03326C81-1449-4C13-B6F6-2CF1F653C004',
  APPLICATION_COOPERATION: '70E3E7EC-B7E8-4800-A123-A24885362211',
} as const;
